// Menu Consultas (2026-10-04). Chave "consultations" fica fora da
// persistência do React Query (dado pessoal) — ver __root.tsx.
import { useQuery } from "@tanstack/react-query";
import { consultationCreditsService, consultationsService } from "@/services/gpsdrive-consultations.service";

export const useConsultationAccess = (enabled = true) =>
  useQuery({
    queryKey: ["consultations", "access"],
    queryFn: consultationsService.access,
    enabled,
    staleTime: 60_000,
    retry: 1,
  });

export const useConsultationSettings = (enabled = true) =>
  useQuery({
    queryKey: ["consultations", "settings"],
    queryFn: consultationsService.settings,
    enabled,
  });

export const useConsultationHistory = (page: number, pageSize: number, document: string) =>
  useQuery({
    queryKey: ["consultations", "list", page, pageSize, document],
    queryFn: () => consultationsService.list({ limit: pageSize, offset: (page - 1) * pageSize, document: document || undefined }),
  });

export const useConsultation = (id: string | null) =>
  useQuery({
    queryKey: ["consultations", "one", id],
    queryFn: () => consultationsService.get(id!),
    enabled: !!id,
  });

// Saldo pago. `polling` = QR do PIX aberto: confere o pagamento a cada 5 s.
export const useConsultationCredits = (enabled = true, polling = false) =>
  useQuery({
    queryKey: ["consultations", "credits"],
    queryFn: consultationCreditsService.status,
    enabled,
    refetchInterval: polling ? 5_000 : false,
    // Bug 2026-10-09: a pessoa ia pra outra aba pagar/confirmar e a
    // conferência parava (aba em segundo plano) — o saldo nunca subia na
    // tela. Continua conferindo em segundo plano e confere ao voltar.
    refetchIntervalInBackground: polling,
    refetchOnWindowFocus: "always",
  });
